<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="px-3 project-selector" style="height: 100%">
        <v-dialog v-model="modalProject" max-width="650px">
            <template v-slot:activator="{ on }">
                <v-layout align-center justify-center row fill-height v-on="on" style="cursor: pointer">
                    <template v-if="token">
                        <template v-if="$utils.isMobile()">
                            <div class="m-item">P</div>
                        </template>
                        <template v-else>
                            <span v-if="currentProject.name">{{currentProject.name}}</span>
                            <span v-else>{{$t('selectAProject') | capitalize}}</span>
                            <v-icon color="white">arrow_drop_down</v-icon>
                        </template>
                    </template>
                </v-layout>
            </template>
            <v-card class="project-dialog">
                <v-card-title class="headline grey lighten-2" primary-title>
                    <span class="headline">{{$t('selectAProject')| capitalize}}</span>
                </v-card-title>
                <v-layout wrap pa-3>
                    <v-flex xs12 sm12 md12>
                        <v-layout row reverse wrap class="pb-3">
                            <v-flex shrink>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <div v-on="on">
                                            <v-btn
                                                color="info"
                                                class="mx-0 btn-create-project"
                                                @click="openCreateProjectDialog"
                                                :disabled="prepaidCount >= $const.MAX_PROJECTS"
                                            >
                                                {{$t('createPrepaidProject')}}
                                            </v-btn>
                                        </div>
                                    </template>
                                    <span>
                                        {{
                                            prepaidCount >= $const.MAX_PROJECTS
                                            ? $t('limitProject')
                                            : $t('createPrepaidProject')
                                        }}
                                    </span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex :class="{'mr-3': $utils.isNotMobile()}">
                                <v-text-field
                                    v-model="search"
                                    append-icon="search"
                                    :label="$filters.capitalize($t('search'))"
                                    single-line
                                    hide-details
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-data-table
                            :headers="headers"
                            :items="projects"
                            :search="search"
                            :pagination.sync="pagination"
                            :rows-per-page-text="$filters.capitalize($t('rowsPerPage'))"
                            v-model="projectSelected"
                            :custom-filter="filter"
                        >
                            <template v-slot:items="props">
                                <tr
                                    :active="currentProject && (props.item.id === currentProject.id)"
                                    @click="selectProject(props.item)"
                                    style="cursor: pointer"
                                >
                                    <td class="text-xs-left">{{ props.item.created_time | formatDate }}</td>
                                    <td class="text-xs-left"><b>{{ props.item.name }}</b></td>
                                    <td class="text-xs-left"><b>{{ props.item.project_type }}</b></td>
                                </tr>
                            </template>
                            <v-alert v-slot:no-results :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dlCreateProject" persistent width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('createPrepaidProject') | capitalize}}
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 sm12 md12>
                                <v-form v-on:submit.prevent="createProject" v-model="formValid">
                                    <v-text-field
                                        ref="refProjectName"
                                        :label="$filters.capitalize($t('selectProjectDialog.newProjectName'))"
                                        required
                                        v-model="projectName"
                                        :rules="formRules.projectName"
                                    ></v-text-field>
                                </v-form>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="dlCreateProject = false">
                        {{$t('cancel')}}
                    </v-btn>
                    <v-btn color="primary" flat @click="createProject">
                        {{$t('create')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import ProjectService from '@/services/project.service'
import { mapState } from 'vuex'
import FormMixin from '@/modules/fptai/mixins/FormMixin'

export default {
    name: 'SelectProject',
    mixins: [FormMixin],
    data () {
        return {
            modalProject: false,
            dlCreateProject: false,
            formValid: false,
            projectSelected: [],
            search: '',
            pagination: {
                'sortBy': 'created_time',
                'descending': true,
                'rowsPerPage': 5
            },
            currentProject: {},
            project: {},
            enableApiFromStarted: '',
            projectName: '',
            notificationText: '',
            snackbar: false,
            alertType: 'info' // success | info | error
        }
    },
    mounted () {
        this.$store.dispatch(this.$actionTypes.user.GET_PROJECTS)
    },
    computed: {
        ...mapState({
            projects: state => state.user.projects,
            token: state => state.user.token,
            currentProjectId: state => state.user.currentProjectId
        }),
        headers () {
            return [
                { text: this.$filters.capitalize(this.$t('createdTime')), value: 'created_time', width: '30%' },
                { text: this.$filters.capitalize(this.$t('name')), value: 'name' },
                { text: this.$filters.capitalize(this.$t('type')), value: 'project_type' }
            ]
        },
        prepaidCount () {
            return this.$store.getters.prepaidProjectCount
        }
    },
    watch: {
        currentProjectId: {
            immediate: true,
            handler (val) {
                if (val) {
                    this.getProject()
                } else {
                    this.currentProject = {}
                }
            }
        },
        token () {
            this.$store.dispatch(this.$actionTypes.user.GET_PROJECTS)
        }
    },
    methods: {
        async getProject () {
            if (this.currentProjectId) {
                await ProjectService.getProjectById(this.currentProjectId).then(res => {
                    this.currentProject = res.data
                }).catch(error => {
                    console.log(error)
                    this.$appService.toastError(this.$t('projectDoesNotExist'))
                    this.$store.dispatch(this.$actionTypes.user.CURRENT_PROJECT_ID, '')
                    this.$router.push('/getting-started')
                })
            }
        },
        selectProject (project) {
            this.$store.dispatch(this.$actionTypes.user.CURRENT_PROJECT_ID, project.id)
            this.$router.push({
                name: 'project',
                params: { project_id: project.id }
            })
            this.modalProject = false
        },
        async createProject () {
            // validate project name
            if (!this.formValid) {
                return false
            }
            let resCreateProject = null
            this.$store.dispatch(this.$actionTypes.LOADING, true)
            // create project
            try {
                resCreateProject = await ProjectService.createProject(this.projectName)
            } catch (error) {
                this.dlCreateProject = false
                ProjectService.handleCreateProjectError(error)
            }
            this.$store.dispatch(this.$actionTypes.LOADING, false)
            if (resCreateProject) {
                if (!resCreateProject.status) {
                    this.$appService.toastError(
                        resCreateProject.data.detail
                            ? resCreateProject.data.detail
                            : this.$t('modalCreateProject.createProjectFailed')
                    )
                } else {
                    this.projectName = ''
                    this.$store.dispatch(this.$actionTypes.user.GET_PROJECTS)
                    // check assign api to project
                    if (this.enableApiFromStarted !== '') {
                        // assign api to project
                        // redirect to api page
                    } else {
                        // redirect to api page
                        this.$store.dispatch(this.$actionTypes.user.CURRENT_PROJECT_ID, resCreateProject.data.id)
                        this.$router.push('/project/' + resCreateProject.data.id + '/apis')
                        this.modalProject = false
                        this.dlCreateProject = false
                        this.currentProject = this.$store.getters.getProject.filter(
                            item => item.id === resCreateProject.data.id
                        )[0]
                    }
                }
            }
        },
        openCreateProjectDialog () {
            this.modalProject = false
            this.dlCreateProject = true
            this.$nextTick(this.$refs.refProjectName.focus)
        },
        filter (items, search) {
            return items.filter(o => o.name.toLowerCase().includes(search.toLowerCase()))
        }
    }
}
</script>
<style scoped>
    .project-selector span {
        color: #fff;
    }

    .m-item {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 3px;
        color: #fff;
        width: 34px;
        height: 34px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
    }

    .btn-create-project {
        pointer-events: auto;
    }
</style>
